import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddAdSubCategory } from "./FormAddSubCategory";

export const PanelAddAdSubCategory = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Ad category</div>
          </div>
        }
      />
      <PanelBody content={<FormAddAdSubCategory />} />
    </div>
  );
};
